/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  SET_ACL,
  FETCH_ACL,
  FETCH_ACL_SUCCESS,
  FETCH_ACL_FAILURE,
  SET_SELF_CERT_STATE,
} from "./actionTypes";
import { Acl } from "./acls";
import * as IntegrationError from "./../../components/settings/integrations/IntegrationError";

function getResponseError(error) {
  if (error.response.data && error.response.data.message) {
    return error.response.data;
  } else {
    return IntegrationError.getDefaultError();
  }
}

export function setACL(acl) {
  return {
    type: SET_ACL,
    acl: acl,
  };
}

export function setSelfCertState(state) {
  return {
    type: SET_SELF_CERT_STATE,
    selfcert: state,
  };
}

export function fetchAcl() {
  return {
    type: FETCH_ACL,
  };
}
export function fetchAclSuccess(aclInfo) {
  return {
    type: FETCH_ACL_SUCCESS,
    aclInfo: aclInfo,
  };
}
export function fetchAclFailure(error) {
  return {
    type: FETCH_ACL_FAILURE,
    errorMessage: error.message,
  };
}

export function getAclData() {
  return (dispatch) => {
    dispatch(fetchAcl());
    return Acl
      .getUser()
      .then((response) => dispatch(fetchAclSuccess(response.data)))
      .catch(function (error) {
        dispatch(fetchAclFailure(getResponseError(error)));
      });
  };
}
